import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

// Provide a safe default value so components/tests using the hook outside
// of a provider don't crash.
const OperatorFilterContext = createContext({
  isFilterDisabled: false,
  setIsFilterDisabled: () => {},
  canDisableFilter: false,
});

export const OperatorFilterProvider = ({ children }) => {
  const { user } = useSelector(state => state.authentication);
  const [isFilterDisabled, setIsFilterDisabled] = useState(() => {
    const savedValue = localStorage.getItem('operatorFilterDisabled');
    return savedValue ? JSON.parse(savedValue) : false;
  });

  const canDisableFilter = user && (
    user.role === 'administrateur' ||
    (user.role === 'ergothérapeute' && user.ergoQualification === 'ergothérapeute interne') ||
    user.role === 'conseiller social'
  );

  useEffect(() => {
    localStorage.setItem('operatorFilterDisabled', JSON.stringify(isFilterDisabled));
  }, [isFilterDisabled]);

  return (
    <OperatorFilterContext.Provider value={{ isFilterDisabled, setIsFilterDisabled, canDisableFilter }}>
      {children}
    </OperatorFilterContext.Provider>
  );
};

export const useOperatorFilter = () => useContext(OperatorFilterContext); 